// @flow
import { post, get } from './common';
import { handleAPIErrors } from '../sentry-util';

export const requestOtpLogin = async (mobile: string, type: 'SIGNUP' | 'FORGOT_MPIN') => {
	try {
		const data = await post('/a/generateOtpLogin', {
			mobile,
			param: type === 'SIGNUP' ? 's' : 'r'
		});
		const { status = false, msg } = data;
		if (!status) {
			throw new Error(msg || 'Error while sending OTP');
		}
		return data;
	} catch (error) {
		handleAPIErrors(error, '/a/generateOtpLogin', 'POST', {
			mobile,
			param: type === 'SIGNUP' ? 's' : 'r'
		});
		throw error;
	}
};

export const validateOTP = async (mobile: string, otp: string, type: 'SIGNUP' | 'FORGOT_MPIN', session: string) => {
	try {
		const data = await post('/a/validateOtpLogin', {
			mobile,
			pin: otp
			// param: type === 'SIGNUP' ? 's': 'r'
		}, { session });
		const { status = false, msg } = data;
		if (!status) {
			throw new Error(msg || 'Error while validating OTP');
		}

		return data;
	} catch (error) {
		handleAPIErrors(error, '/a/validateOtpLogin', 'POST', {
			mobile,
			pin: otp
		});
		throw error;
	}
};

export const login = async (mobile: string, pin: string, session?: string) => {
	try {
		const data = await post('/a/login', { mobile, pin }, { session });
		const { status = false, msg } = data;
		if (!status) {
			throw new Error(msg || 'Error while logging in');
		}

		return data;
	} catch (error) {
		handleAPIErrors(error, '/a/login', 'POST', { mobile, pin });
		throw error;
	}
};

export const chkSessionValidity = async (sessionId: string) => {
	try {
		const data = await post('/pwa/login/isSessionValid', { sessionId });
		const { status = false, msg } = data;
		if (!status) {
			throw new Error(msg);
		}

		return data;
	} catch (error) {
		handleAPIErrors(error, '/pwa/login/isSessionValid', 'POST', { sessionId });
		throw error;
	}
};

export const setMpin = async ({ mobile, mpin: pin }: { mobile: string, mpin: string }) => {
	try {
		const data = await post('/a/setPin', { mobile, pin });
		const { status = false, msg } = data;
		if (!status) {
			throw new Error(msg || 'Error while setting Mpin');
		}

		return data;
	} catch (error) {
		handleAPIErrors(error, '/a/setPin', 'POST', { mobile, pin });
		throw error;
	}
};

export const tokenAuthentication = async (token: string, session?: string) => {
	try {
		const data = await get(`/a/l/${token}`, {}, { session });
		const { status = false, msg } = data;
		if (!status) {
			throw new Error(msg || 'Error while authenticating');
		}

		return data;
	} catch (error) {
		handleAPIErrors(error, `a/l/${token}`, 'GET');
		throw error;
	}
};

export const fetchSessionId = async (session: string) => {
	try {
		const data = await get('/a/getSession', {}, {session});
		const { status = false, msg } = data;
		if (!status) {
			throw new Error(msg || 'Error while fetching session');
		}

		return data;
	} catch (error) {
		// handleAPIErrors(error, `a/l/${token}`, 'GET');
		throw error;
	}
};

export const logout = async (session: string) => {
	try {
		const data = await post('/a/logout', {}, {session});
		const { status = false, msg } = data;
		if (!status) {
			throw new Error(msg || 'logout error');
		}

		return data;
	} catch (error) {
		// handleAPIErrors(error, `a/l/${token}`, 'GET');
		throw error;
	}
};

export const updateSessionData = async (data: {[key: string]: any}, session: string) => {
	try {
		const res = await post('/a/updateSession', data , {session});
		const { status = false, msg } = res;
		if (!status) {
			throw new Error(msg || 'logout error');
		}

		return res;
	} catch (error) {
		// handleAPIErrors(error, `a/l/${token}`, 'GET');
		throw error;
	}
};

